var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQhand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 93,
    viewBox: "0 0 94 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.2056 21.7664C53.2056 21.7664 58.4315 26.9148 59.5842 27.2994C60.7369 27.6839 62.5813 27.6065 63.6574 26.4538C64.7336 25.301 66.0394 23.9178 64.8867 22.458C63.734 20.9982 60.5064 18.2317 60.5064 18.2317C60.5064 18.2317 58.816 16.6944 57.8164 15.9263",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0557 22.0735C49.0557 22.0735 51.255 24.5311 54.881 23.3793",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8056 25.7621C68.8056 25.7621 70.3429 28.5489 72.8789 27.0015C75.4148 25.4541 77.1052 23.6863 77.1052 23.6863L78.873 22.0735L81.3324 20.0751C81.3324 20.0751 82.6391 18.9713 81.6395 17.0015C80.5292 14.8114 73.5705 8.93255 71.4956 7.08821C71.4956 7.08821 69.2667 5.01333 66.9613 2.70791C64.6559 0.402487 62.3505 2.55391 61.2743 3.24553C60.1981 3.93716 58.2772 6.08858 56.2789 7.3953C54.2806 8.70201 54.1127 9.39364 51.9678 11.084C49.8237 12.7743 42.7534 17.7466 41.9078 21.7157C41.4513 23.8597 41.3702 23.9943 41.0622 25.6847C40.7551 27.375 41.6773 28.2206 41.8303 29.9884C41.9834 31.7562 42.9065 60.8046 42.676 62.1878C42.4454 63.5711 42.3689 75.7133 42.522 80.1701",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2881 30.0657C47.2881 30.0657 49.9006 31.603 53.9738 30.6033C58.047 29.6046 57.3554 29.6812 58.6612 29.5272C59.967 29.3732 61.4277 29.873 63.0415 29.873C64.6553 29.873 68.8051 28.9951 70.8799 28.8936C72.9548 28.7922 76.259 29.434 78.7184 30.9409C78.7184 30.9409 81.1391 32.7548 84.3667 33.735C87.5943 34.7144 88.4454 34.1223 88.4454 34.1223",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8726 22.4351C80.6247 23.929 79.649 23.2539 82.2385 24.4334",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0004 29.6121C58.0004 29.6121 57.1253 36.2895 58.4311 43.3598C59.7369 50.43 60.506 53.9647 61.6587 58.8061C62.8114 63.6475 63.1185 63.1099 64.8097 68.3349C66.5001 73.5608 68.883 80.9999 68.883 80.9999",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9609 2.70786C66.9609 2.70786 70.9567 -1.13482 73.9537 2.70786C74.5965 3.53228 78.1035 7.08816 78.1035 7.08816C78.1035 7.08816 83.7131 12.2366 85.0198 14.0044C86.3265 15.7722 86.9407 19.1529 88.8625 23.0721C90.7833 26.9913 94.78 33.062 91.475 34.2921C87.4875 35.7759 85.5574 30.68 84.3282 28.2981C83.0989 25.9161 82.2533 23.9177 81.5616 22.8803C80.87 21.8429 80.0705 21.0996 80.0705 21.0996",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4997 12.1599C66.4997 12.1599 67.3454 13.0055 68.8817 14.1583C70.4189 15.311 73.7996 18.0009 73.9536 19.3842C74.1076 20.7674 74.9523 22.1507 69.6499 24.9937C69.6499 24.9937 66.5274 26.9248 64.707 25.2298",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0508 66.4258C37.0508 69.082 36.6211 71.3932 35.7617 73.3594C34.9023 75.3125 33.7109 76.8815 32.1875 78.0664L36.9141 81.7773L33.1836 85.0781L27.1289 80.2148C26.4388 80.332 25.7227 80.3906 24.9805 80.3906C22.6237 80.3906 20.5208 79.8242 18.6719 78.6914C16.8229 77.5586 15.3906 75.944 14.375 73.8477C13.3594 71.7383 12.8451 69.3164 12.832 66.582V65.1758C12.832 62.3763 13.3333 59.9154 14.3359 57.793C15.3516 55.6576 16.7773 54.0234 18.6133 52.8906C20.4622 51.7448 22.5716 51.1719 24.9414 51.1719C27.3112 51.1719 29.4141 51.7448 31.25 52.8906C33.099 54.0234 34.5247 55.6576 35.5273 57.793C36.543 59.9154 37.0508 62.3698 37.0508 65.1562V66.4258ZM31.1133 65.1367C31.1133 62.1549 30.5794 59.8893 29.5117 58.3398C28.444 56.7904 26.9206 56.0156 24.9414 56.0156C22.9753 56.0156 21.4583 56.7839 20.3906 58.3203C19.3229 59.8438 18.7826 62.0833 18.7695 65.0391V66.4258C18.7695 69.3294 19.3034 71.582 20.3711 73.1836C21.4388 74.7852 22.9753 75.5859 24.9805 75.5859C26.9466 75.5859 28.457 74.8177 29.5117 73.2812C30.5664 71.7318 31.1003 69.4792 31.1133 66.5234V65.1367Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 68.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQhand);
export default __webpack_public_path__ + "static/media/Qhand.a08153399ec125f8db3ee7a4fdc21b24.svg";
export { ForwardRef as ReactComponent };